module.exports = __webpack_public_path__ + "img/member-detail-photo.409b2f22.svg";